import React, { Component } from 'react';
import Modal from 'react-bootstrap4-modal';

import './LoginForm.css';

class LoginForm extends Component {
  constructor(props) {
      super(props);

      this.state = {
          visibility: false,
          userName: '',
          password: ''
      }

      this.hide = this.hide.bind(this);
      this.show = this.show.bind(this);
      this._handleUserNameChange = this._handleUserNameChange.bind(this);
      this._handlePasswordChange = this._handlePasswordChange.bind(this);
      this._handleSubmit = this._handleSubmit.bind(this);
  }

  hide() {
      this.setState({ visibility: false });
  }

  show() {
      this.setState({ visibility: true });
  }

  _handleUserNameChange(event) {
      this.setState({ userName: event.target.value });
  }

  _handlePasswordChange(event) {
      this.setState({ password: event.target.value });
  }

  _handleSubmit() {
    this.hide();
    
    if (this.props.onSubmit != null) {
        const { userName, password } = this.state;

        let event = new Event('submit');
        event.detail = {
            userName: userName,
            password: password
        };

        this.props.onSubmit(event);
    }
  }

  render() {
      const { visibility, userName, password } = this.state;

      return(
          <Modal visible={ visibility } onClickBackdrop={ this.hide }>
              <div className="modal-header">
                  <h5 className="modal-title">Login</h5>
              </div>
              <div className="modal-body">
                  <p>Please, enter your credentials to proceed.</p>
                  <div className="form-row">
                      <div className="form-group offset-md-2 col-md-8 col-sm-12 align-self-center">
                          <label>Email</label>
                          <input type="email" className="form-control" placeholder="Email" value={ userName } onChange={ this._handleUserNameChange }></input>
                      </div>
                      <div className="form-group offset-md-2 col-md-8 col-sm-12 align-self-center">
                          <label>Password</label>
                          <input type="password" className="form-control" placeholder="Password" value={ password } onChange={ this._handlePasswordChange }></input>
                      </div>
                  </div>
              </div>
              <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={ this.hide }>
                      Cancel
                  </button>
                  <button type="button" className="btn btn-primary" onClick={ this._handleSubmit }>
                      Login
                  </button>
              </div>
          </Modal>
      );
  }
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/_components/login_form/LoginForm.jsx